// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Empty State Styles
 * Consistent empty state for all management pages
 */

/* Unified Empty State */
.unified-empty-state {
    text-align: center;
    padding: 60px 20px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
    margin: 0 25px 30px 25px;
}

.unified-empty-icon {
    font-size: 4rem;
    margin-bottom: 20px;
    opacity: 0.6;
}

.unified-empty-title {
    color: #2d3748;
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 12px 0;
}

.unified-empty-description {
    color: #4a5568;
    font-size: 1rem;
    margin: 0 0 24px 0;
    line-height: 1.5;
}

.unified-empty-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
}

.unified-empty-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.unified-empty-action-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.unified-empty-action-btn.primary {
    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
    color: white;
}

.unified-empty-action-btn.primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.unified-empty-action-btn.secondary {
    background: #f8f9fa;
    color: #495057;
    border: 1px solid #dee2e6;
}

.unified-empty-action-btn.secondary:hover:not(:disabled) {
    background: #e9ecef;
    transform: translateY(-1px);
}

.unified-empty-action-btn.outline {
    background: transparent;
    color: #0D3B66;
    border: 1px solid #0D3B66;
}

.unified-empty-action-btn.outline:hover:not(:disabled) {
    background: #0D3B66;
    color: white;
}

.unified-empty-action-icon {
    font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
    .unified-empty-state {
        margin: 0 20px 20px 20px;
        padding: 40px 20px;
    }

    .unified-empty-icon {
        font-size: 3rem;
        margin-bottom: 16px;
    }

    .unified-empty-title {
        font-size: 1.25rem;
    }

    .unified-empty-description {
        font-size: 0.9rem;
    }

    .unified-empty-actions {
        flex-direction: column;
        align-items: center;
    }

    .unified-empty-action-btn {
        width: 100%;
        max-width: 200px;
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .unified-empty-state {
        margin: 0 15px 15px 15px;
        padding: 30px 15px;
    }

    .unified-empty-icon {
        font-size: 2.5rem;
        margin-bottom: 12px;
    }

    .unified-empty-title {
        font-size: 1.1rem;
    }

    .unified-empty-description {
        font-size: 0.85rem;
    }

    .unified-empty-action-btn {
        padding: 10px 20px;
        font-size: 0.85rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedEmptyState.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,wBAAwB;AACxB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,yCAAyC;IACzC,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI;QACI,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ","sourcesContent":["/**\n * Unified Empty State Styles\n * Consistent empty state for all management pages\n */\n\n/* Unified Empty State */\n.unified-empty-state {\n    text-align: center;\n    padding: 60px 20px;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(20px);\n    border-radius: 16px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    margin: 0 25px 30px 25px;\n}\n\n.unified-empty-icon {\n    font-size: 4rem;\n    margin-bottom: 20px;\n    opacity: 0.6;\n}\n\n.unified-empty-title {\n    color: #2d3748;\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n}\n\n.unified-empty-description {\n    color: #4a5568;\n    font-size: 1rem;\n    margin: 0 0 24px 0;\n    line-height: 1.5;\n}\n\n.unified-empty-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.unified-empty-action-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 24px;\n    border: none;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    text-decoration: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    white-space: nowrap;\n}\n\n.unified-empty-action-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.unified-empty-action-btn.primary {\n    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n    color: white;\n}\n\n.unified-empty-action-btn.primary:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.unified-empty-action-btn.secondary {\n    background: #f8f9fa;\n    color: #495057;\n    border: 1px solid #dee2e6;\n}\n\n.unified-empty-action-btn.secondary:hover:not(:disabled) {\n    background: #e9ecef;\n    transform: translateY(-1px);\n}\n\n.unified-empty-action-btn.outline {\n    background: transparent;\n    color: #0D3B66;\n    border: 1px solid #0D3B66;\n}\n\n.unified-empty-action-btn.outline:hover:not(:disabled) {\n    background: #0D3B66;\n    color: white;\n}\n\n.unified-empty-action-icon {\n    font-size: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .unified-empty-state {\n        margin: 0 20px 20px 20px;\n        padding: 40px 20px;\n    }\n\n    .unified-empty-icon {\n        font-size: 3rem;\n        margin-bottom: 16px;\n    }\n\n    .unified-empty-title {\n        font-size: 1.25rem;\n    }\n\n    .unified-empty-description {\n        font-size: 0.9rem;\n    }\n\n    .unified-empty-actions {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .unified-empty-action-btn {\n        width: 100%;\n        max-width: 200px;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 480px) {\n    .unified-empty-state {\n        margin: 0 15px 15px 15px;\n        padding: 30px 15px;\n    }\n\n    .unified-empty-icon {\n        font-size: 2.5rem;\n        margin-bottom: 12px;\n    }\n\n    .unified-empty-title {\n        font-size: 1.1rem;\n    }\n\n    .unified-empty-description {\n        font-size: 0.85rem;\n    }\n\n    .unified-empty-action-btn {\n        padding: 10px 20px;\n        font-size: 0.85rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
